import React, { useState } from 'react'
import ContributionFilter from './ContributionsFilter'
import { Table, Button } from 'antd'
import { GetReceiptsApi } from '../../services/apiService'
import { showApiError, showApiSuccess } from '../utilities'
import { CSVLink } from 'react-csv'
import "moment/locale/en-nz"
import moment from "moment"
import CreateAndSavePDF from './GenerateReceipts'


function ReceiptsContainer(props) {
  const [data, setData] = useState([])
  const [readyPDF, setReadyPDF] = useState(false)
  let today = moment()
  let fromDate = moment().day(0)

  function handleSearch(search) {
    let querystring = `?from=${search.fromDate}&to=${search.toDate}&contId=${search.contId}`
    //console.log(`${querystring}`)
    LoadData(querystring)
  }

  let columns = [
    {
      title: 'Offering No',
      dataIndex: 'offeringNo',
      key: 'offeringNo',
    },
    {
      title: 'Name',
      dataIndex: 'displayName'
    },
    {
      title: 'Amount',
      dataIndex: 'totalAmount'
    },

  ]

  function FinishDownloadPDF() {
    setReadyPDF( false )
  }

  function LoadData(querystring) {
    GetReceiptsApi(querystring)
      .then(json => {
        if (typeof json === "string") {
          throw new Error(json);
        } else {
          //json 
          setData(json)
          if (json.length < 1)  {
            showApiSuccess("No record found")
          }
        }
      })
      .catch(error => {
        showApiError(error);
      });

  }

  function ShowTable() {
    if (data.length > 0) {
      return (
        <div >
          <div className='buttonsbar'>
            <CSVLink data={data} filename='tax_certificates.csv' >
            <Button icon='file-excel'>Download CSV</Button> </CSVLink>
            <Button icon='file-pdf' onClick={()=>setReadyPDF(true)} >Download PDF</Button> 
            <CreateAndSavePDF data={data} ready={readyPDF} doFinish={FinishDownloadPDF} />
            {/*<PDFDownloadLink document={<GetPDF data={data} />} fileName="tax-cert.pdf">
            <Button icon='file-pdf'>Download PDF</Button> </PDFDownloadLink> */}
          </div> 
          <Table dataSource={data} columns={columns}
            rowKey="offeringNo" pagination={false}
            size="small" />
        </div>)
    }

    return null

  }

  return (
    <div className="content">
      <h2>{props.title}</h2>
      <ContributionFilter fromDate={fromDate} toDate={today} doSearch={handleSearch}
        button1Title='Get'
        groupBy={-1} />
      <ShowTable/>
    </div>
  )

}

export default ReceiptsContainer;